// This is the real image width and height on Sanity. We don't care about scaling width on screen size

export enum AbsoluteBackgroundImage {
  WIDTH = 1800,
  HEIGHT = 400,
}
